var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"submit"},on:{"click":_vm.clicked}},[(_vm.saving)?_c('i',{staticClass:"fa fa-refresh fa-spin fa-fw"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }